'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _goals = require('redux/modules/goals');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Strategies = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    profile: state.profile.data,
    goals: state.goals.data.goals,
    barriers: state.goals.data.barriers,
    strategies: state.goals.data.strategies
  };
}, { updateStrategies: _goals.updateStrategies }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Strategies, _Component);

  function Strategies() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Strategies);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Strategies.__proto__ || (0, _getPrototypeOf2.default)(Strategies)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isEdit: false,
      strategies: _this.props.strategies || [{
        strategy: 'Strategy 1',
        steps: 'steps',
        whatIsNeeded: 'whatIsNeeded',
        isEffective: 'effect',
        comments: 'comments'
      }]
    }, _this.handleClickEdit = function () {
      var obj = _this.state;
      obj.isEdit = !obj.isEdit;

      if (!obj.isEdit) {
        _this.props.updateStrategies(_this.props.user.userId, _this.state.strategies);
      }

      _this.setState(obj);
    }, _this.handleChange = function (str, index, event) {
      var obj = _this.state;
      if (str === 'strategy') {
        obj.strategies[index].strategy = event.target.value;
      }

      if (str === 'steps') {
        obj.strategies[index].steps = event.target.value;
      }

      if (str === 'whatIsNeeded') {
        obj.strategies[index].whatIsNeeded = event.target.value;
      }

      if (str === 'isEffective') {
        obj.strategies[index].isEffective = !obj.strategies[index].isEffective;
      }

      if (str === 'comments') {
        obj.strategies[index].comments = event.target.value;
      }

      _this.setState(obj);
    }, _this.handleAddStrategy = function () {
      var obj = _this.state;
      obj.strategies.push({ strategy: '', isEffective: '', comments: '' });
      _this.setState(obj);
    }, _this.handleRemoveStrategy = function (index) {
      var obj = _this.state;
      obj.strategies.splice(index, 1);
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /* User clicks on edit button */


  /*
   * Adds a strategy to the front end UI
   */


  (0, _createClass3.default)(Strategies, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Profile.scss');

      return _react2.default.createElement(
        'div',
        null,
        !this.state.isEdit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 12, sm: 12, lg: 12, xs: 12 },
            _react2.default.createElement('div', { className: styles.spacer30 }),
            _react2.default.createElement(
              'h2',
              { className: styles.orangeText + ' ' + styles.textCenter },
              'My strategies'
            ),
            _react2.default.createElement('hr', { className: styles.small }),
            _react2.default.createElement(
              ReactBootstrap.Table,
              { striped: true, bordered: true },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Strategies'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Steps'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'What is needed to do this'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Was it effective'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Other comments'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                this.state.strategies.map(function (item, index) {
                  return _react2.default.createElement(
                    'tr',
                    { key: 'strat' + index },
                    _react2.default.createElement(
                      'td',
                      null,
                      item.strategy
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      item.steps
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      item.whatIsNeeded
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      item.isEffective && _react2.default.createElement('i', { className: styles.orangeText + ' fa fa-2x fa-check' })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      item.comments
                    )
                  );
                })
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.ButtonToolbar,
              null,
              _react2.default.createElement(
                ReactBootstrap.Button,
                { className: 'pull-right',
                  bsStyle: 'success', onClick: this.handleClickEdit },
                _react2.default.createElement('i', { className: 'fa fa-user-o' }),
                '  Edit strategies'
              )
            )
          )
        ),
        this.state.isEdit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 12, sm: 12, lg: 12, xs: 12 },
            _react2.default.createElement('div', { className: styles.spacer30 }),
            _react2.default.createElement(
              'h2',
              { className: styles.orangeText + ' ' + styles.textCenter },
              'My strategies'
            ),
            _react2.default.createElement('hr', { className: styles.small }),
            _react2.default.createElement(
              ReactBootstrap.Table,
              { striped: true, bordered: true },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Strategies'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Steps'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'What is needed to do this'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Was it effective'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Other comments'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                this.state.strategies.map(function (item, index) {
                  return _react2.default.createElement(
                    'tr',
                    { key: 'editstrat' + index },
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea',
                        placeholder: 'Strategy',
                        value: item.strategy,
                        onChange: _this2.handleChange.bind(_this2, 'strategy', index) })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea',
                        placeholder: 'Steps for this strategy',
                        value: item.steps,
                        onChange: _this2.handleChange.bind(_this2, 'steps', index) })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea',
                        placeholder: 'What is needed for this strategy',
                        value: item.whatIsNeeded,
                        onChange: _this2.handleChange.bind(_this2, 'whatIsNeeded', index) })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(ReactBootstrap.Checkbox, { onChange: _this2.handleChange.bind(_this2, 'isEffective', index),
                        checked: item.isEffective })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(ReactBootstrap.FormControl, { componentClass: 'textarea',
                        placeholder: 'Any additional comments you would like to make',
                        value: item.comments,
                        onChange: _this2.handleChange.bind(_this2, 'comments', index) })
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(
                        ReactBootstrap.Button,
                        { bsSize: 'large', bsStyle: 'danger',
                          onClick: _this2.handleRemoveStrategy.bind(_this2, index) },
                        _react2.default.createElement('i', { className: 'fa fa-close' })
                      )
                    )
                  );
                })
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.ButtonToolbar,
                null,
                _react2.default.createElement(
                  ReactBootstrap.Button,
                  { bsStyle: 'success', onClick: this.handleAddStrategy },
                  _react2.default.createElement('i', { className: 'fa fa-plus' }),
                  '  Add strategy'
                ),
                _react2.default.createElement(
                  ReactBootstrap.Button,
                  { className: 'pull-right',
                    bsStyle: 'success', onClick: this.handleClickEdit },
                  _react2.default.createElement('i', { className: 'fa fa-user-o' }),
                  '  Save strategies'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Strategies;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  goals: _propTypes2.default.array,
  barriers: _propTypes2.default.array,
  strategies: _propTypes2.default.array,
  updateStrategies: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Strategies;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/Strategies.js
// module id = 1228
// module chunks = 0